export default "/images/vendor/flag-icon-css/flags/4x3/mp.svg?394b0c91d8212a6cb6db896dcbd08758";